export const LANGUAGES = {
  EN: {name: 'en', iso: 'en-GB', flag: 'gb'},
  FR: {name: 'fr', iso: 'fr-FR', flag: 'fr'},
  DE: {name: 'de', iso: 'de-DE', flag: 'de'},
  IT: {name: 'it', iso: 'it-IT', flag: 'it'},
  ES: {name: 'es', iso: 'es-ES', flag: 'es'},
  NL: {name: 'nl', iso: 'nl-NL', flag: 'nl'},
  UK: {name: 'uk', iso: 'ua-UA', flag: 'ua'},
  NO: {name: 'no', iso: 'no-NO', flag: 'no'}, // testing purposes -> add Norwegian in weglot and flag wont be broken
};
export const DATEPLACEHOLDER = {
  EN: {day: 'DD', month: 'MM', year: 'YYYY', separator: '/'},
  FR: {day: 'JJ', month: 'MM', year: 'AAAA', separator: '/'},
  DE: {day: 'TT', month: 'MM', year: 'JJJJ', separator: '.'},
  IT: {day: 'GG', month: 'MM', year: 'AAAA', separator: '/'},
  ES: {day: 'DD', month: 'MM', year: 'AAAA', separator: '/'},
  NL: {day: 'DD', month: 'MM', year: 'JJJJ', separator: '-'},
  NO: {day: 'DD', month: 'MM', year: 'ÅÅÅÅ', separator: '.'},
};
export const BANKICONS = {
  FR: [
    'banque_populaire.png',
    'credit_mutuel.png',
    'bnp_paribas.png',
    'caisse_d_epargne.png',
    'stripe.png',
    'qonto.png',
  ],
  EN: [
    'commerzbank.png',
    'ing.png',
    'bnp_paribas.png',
    'caisse_d_epargne.png',
    'stripe.png',
    'qonto.png',
  ],
  DE: [
    'commerzbank.png',
    'ing.png',
    'vr_bank.png',
    'revolut.png',
    'stripe.png',
    'qonto.png',
  ],
  IT: [
    'unicredit.png',
    'revolut.png',
    'bnp_paribas.png',
    'intesa.png',
    'stripe.png',
    'qonto.png',
  ],
  ES: [
    'sabadell.png',
    'revolut.png',
    'bbva.png',
    'caixa_bank.png',
    'stripe.png',
    'qonto.png',
  ],
  NL: [
    'rabobank.png',
    'revolut.png',
    'ing.png',
    'bnp_paribas.png',
    'stripe.png',
    'qonto.png',
  ],
};
export const CONFIRMERTRANSLATED = {
  FR: 'CONFIRMER',
  ES: 'CONFIRMAR',
  IT: 'CONFERMARE',
  DE: 'BETSTÄTIGEN',
  NL: 'BEVESTIGEN',
  EN: 'CONFIRM',
};
export const SUPPRIMERTRANSLATED = {
  FR: 'SUPPRIMER',
  ES: 'BORRAR',
  IT: 'ELIMINARE',
  DE: 'LÖSCHEN',
  NL: 'VERWIDJEREN',
  EN: 'DELETE',
};
export const PREVISIONMANUELLETRANSLATED = {
  FR: 'Prévision manuelle',
  ES: 'Previsión manual',
  IT: 'Previsione manuale',
  DE: 'Manuelle Prognose',
  NL: 'Handmatige voorspelling',
  EN: 'Manual forecast',
};
export const CENTRALBANKICONS = {
  FR: ['france_central_bank.png'],
  EN: null,
  DE: ['german_central_bank.png'],
  IT: ['italian_central_bank.png'],
  ES: ['spain_central_bank.png'],
  NL: ['nl_central_bank.svg'],
};
